import { render } from "./note_editor.vue?vue&type=template&id=6cfed22f&scoped=true"
import script from "./note_editor.vue?vue&type=script&lang=js"
export * from "./note_editor.vue?vue&type=script&lang=js"

import "./note_editor.vue?vue&type=style&index=0&id=6cfed22f&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfed22f"]])

export default __exports__